import react from 'react';

export class Checkbox extends react.Component {
  constructor(props) {
    super(props);
    this.state = { 
      label: props.label, 
      htmlFor: props.htmlFor, 
      props: props.placeholder, 
      value: props.value, 
      error: props.error, 
      onChange: props.onChange,
      className: props.className ? props.className : ""
    };
  }

  componentWillReceiveProps(props) {
    this.setState(
      { 
        label: props.label, 
        htmlFor: props.htmlFor, 
        props: props.placeholder, 
        value: props.value, 
        error: props.error, 
        onChange: props.onChange,
        className: props.className ? props.className : ""
      });  
  }

  render() {
    return <div className={`checkbox-group ${this.state.className}`}>
      <input type="checkbox" className="form-check-input"  id={this.state.htmlFor} checked={this.state.value} onChange={this.state.onChange}/>
      <label htmlFor={this.state.htmlFor}>
        {this.state.label}
      </label>
    </div>
  }
}